import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'main',
    loadChildren: () => import('./main/main.module').then( m => m.MainPageModule)
  },
  {
    path: 'scan',
    loadChildren: () => import('./scan/scan.module').then( m => m.ScanPageModule)
  },
  {
    path: 'smartphone',
    loadChildren: () => import('./smartphone/smartphone.module').then( m => m.SmartphonePageModule)
  },
  {
    path: 'expedition',
    loadChildren: () => import('./expedition/expedition.module').then( m => m.ExpeditionPageModule)
  },
  {
    path: 'livraisonphotos',
    loadChildren: () => import('./livraisonphotos/livraisonphotos.module').then( m => m.LivraisonphotosPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
